import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorCtMySubscriber = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      d="M15.065 12.058a.75.75 0 0 0-1.061-1.06l-3.007 3.006a.75.75 0 0 0 1.06 1.06l3.008-3.006Z"
    />
    <path
      fill={getTheme(props["data-theme"])}
      d="M21.616 16.139a2.75 2.75 0 0 0 0-3.89l-8.253-8.252a2.75 2.75 0 0 0-1.842-.803l-5.688-.211a2.75 2.75 0 0 0-2.85 2.85l.21 5.688a2.75 2.75 0 0 0 .804 1.842l8.253 8.253a2.75 2.75 0 0 0 3.889 0l5.477-5.477Zm-1.06-2.828a1.25 1.25 0 0 1 0 1.767l-5.478 5.477a1.25 1.25 0 0 1-1.768 0l-8.252-8.252a1.25 1.25 0 0 1-.365-.838l-.211-5.688a1.25 1.25 0 0 1 1.295-1.295l5.688.21c.315.012.615.143.838.366l8.252 8.253Z"
    />
    <path
      fill="#F7A600"
      d="M12.029 9.573a2.255 2.255 0 1 1-4.51 0 2.255 2.255 0 0 1 4.51 0Z"
    />
  </svg>
);
export default SvgTwoColorCtMySubscriber;
